import { Environment } from './environment.d'
import { localEnvironment } from './environment.local'
import { AWSEnvironment } from './environment.aws'

let environment: Environment

if (process.env.NODE_ENV === 'production') {
  environment = AWSEnvironment
}
else {
  environment = localEnvironment
}

export default environment
